import {
  formatCategoriesWithBullet,
  Routes,
  useLocale,
  formatArticleDate,
} from '@xolv-mybrightlink/common';
import { Box, Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router';
import { Article } from '../models/ArticleResult';

type ArticleCardProps = {
  article: Article;
  isFirstArticle?: boolean;
};

export const ArticleCard = (props: ArticleCardProps) => {
  const locale = useLocale();
  const navigate = useNavigate();

  const onArticleClicked = () => {
    navigate(
      Routes.resources.articles.slug(props.article.slug, 'all-articles'),
    );
  };

  return (
    <Box
      onClick={onArticleClicked}
      sx={{
        width: '100%',
        height: '100%',
        position: 'relative',
        background: `linear-gradient(to bottom, rgba(59, 69, 89, 0) 0%,rgba(59, 69, 89, 0) 36%, rgba(59, 69, 89, 0.95) 86%), url('${props.article.featuredImage.node.sourceUrl}') no-repeat`,
        backgroundSize: 'cover',
        cursor: 'pointer',
      }}
    >
      <Box
        sx={{
          borderBottomRightRadius: 12,
          backgroundColor: '#626a7a',
          height: 26,
          position: 'absolute',
          top: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          left: 0,
        }}
      >
        <Typography
          sx={{
            pl: 2.5,
            pr: 5,
            py: 1,
            fontSize: 12,
            color: '#fff',
          }}
        >
          {formatArticleDate(props.article.date, locale)}
        </Typography>
      </Box>
      <Stack
        sx={{
          p: 2.5,
          position: 'absolute',
          bottom: 0,
          left: 0,
        }}
      >
        <Typography
          gutterBottom
          variant='body1'
          fontWeight={'500'}
          sx={{
            color: '#fff',
            display: '-webkit-box',
            overflow: 'hidden',
            WebkitBoxOrient: 'vertical',
            fontWeight: 600,
            textOverflow: 'ellipsis',
            WebkitLineClamp: props.isFirstArticle ? 2 : 1,
          }}
        >
          {props.article.title}
        </Typography>
        <Typography
          variant='caption'
          sx={{
            color: '#fff',
          }}
        >
          {formatCategoriesWithBullet(props.article.categories.nodes)}
        </Typography>
      </Stack>
    </Box>
  );
};
